import React from 'react';

export const EditIcon = ({ color = '#2555FE', ...restProps }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      stroke={color}
      {...restProps}
    >
      <path
        d="M7.33334 2.6665H2.66668C2.31305 2.6665 1.97392 2.80698 1.72387 3.05703C1.47382 3.30708 1.33334 3.64622 1.33334 3.99984V13.3332C1.33334 13.6868 1.47382 14.0259 1.72387 14.276C1.97392 14.526 2.31305 14.6665 2.66668 14.6665H12C12.3536 14.6665 12.6928 14.526 12.9428 14.276C13.1929 14.0259 13.3333 13.6868 13.3333 13.3332V8.6665"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.3333 1.66665C12.5986 1.40144 12.9583 1.25244 13.3333 1.25244C13.7084 1.25244 14.0681 1.40144 14.3333 1.66665C14.5986 1.93187 14.7476 2.29158 14.7476 2.66665C14.7476 3.04173 14.5986 3.40144 14.3333 3.66665L8.00001 9.99999L5.33334 10.6667L6.00001 7.99999L12.3333 1.66665Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default EditIcon;
